export default __webpack_public_path__ + "static/media/detail_big_16_2.6733c550.jpg";